(() => {
  const selectorUi = [
    'localization-form',
    'country-selector',
    'language-selector',
    'market-selector',
    '.localization-form',
    '.shopify-localization-form',
    '.localization-selector',
    '.country-selector',
    '.language-selector',
    '.market-selector',
    '[data-localization-form]',
    '[data-localization-selector]',
    '[data-country-selector]',
    '[data-language-selector]',
    '[data-market-selector]',
    'form[action$="/localization"]'
  ].join(',');

  const marketRoot = window.Shopify?.routes?.root || '/';
  const normalizedRoot = marketRoot === '/' ? '/' : marketRoot.replace(/\/$/, '');

  const marketAwareUrl = (value) => {
    if (!value || normalizedRoot === '/' || !value.startsWith('/') || value.startsWith('//')) return value;
    if (value === '/') return normalizedRoot;
    if (value === normalizedRoot || value.startsWith(`${normalizedRoot}/`)) return value;
    return `${normalizedRoot}${value}`;
  };

  const normalizeStorefront = (scope = document) => {
    if (scope.matches?.(selectorUi)) {
      scope.remove();
      return;
    }
    scope.querySelectorAll?.(selectorUi).forEach((element) => element.remove());
    if (scope.matches?.('a[href]')) {
      const href = scope.getAttribute('href');
      const normalizedHref = marketAwareUrl(href);
      if (normalizedHref !== href) scope.setAttribute('href', normalizedHref);
    }
    scope.querySelectorAll?.('a[href]').forEach((link) => {
      const href = link.getAttribute('href');
      const normalizedHref = marketAwareUrl(href);
      if (normalizedHref !== href) link.setAttribute('href', normalizedHref);
    });
    if (scope.matches?.('form[action]')) {
      const action = scope.getAttribute('action');
      const normalizedAction = marketAwareUrl(action);
      if (normalizedAction !== action) scope.setAttribute('action', normalizedAction);
    }
    scope.querySelectorAll?.('form[action]').forEach((form) => {
      const action = form.getAttribute('action');
      const normalizedAction = marketAwareUrl(action);
      if (normalizedAction !== action) form.setAttribute('action', normalizedAction);
    });
  };

  normalizeStorefront();
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const href = link.getAttribute('href');
    const normalizedHref = marketAwareUrl(href);
    if (normalizedHref !== href) link.setAttribute('href', normalizedHref);
  }, true);
  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('form[action]');
    if (!form) return;
    const action = form.getAttribute('action');
    const normalizedAction = marketAwareUrl(action);
    if (normalizedAction !== action) form.setAttribute('action', normalizedAction);
  }, true);
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) normalizeStorefront(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
